/**
 * Stable 32-bit string hash (djb2). Useful for deterministic mapping of strings
 * (e.g. IDs) to numeric ranges — cache TTL jitter, placeholder indices, etc.
 */
export function simpleStringHash(str: string) {
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) + hash + str.charCodeAt(i);
    hash |= 0;
  }
  return hash | 0;
}
